<template>
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M29.6486 6.79434L29.6486 6.79442C29.9722 7.42949 30.1641 8.21507 30.2641 9.43869C30.3652 10.6763 30.3662 12.2536 30.3662 14.4528V16.2962C30.3662 19.01 30.3539 20.1095 30.1002 20.975C29.4693 23.1265 27.787 24.8088 25.6355 25.4397C24.77 25.6934 23.6705 25.7057 20.9567 25.7057L20.1024 25.7057L20.1006 25.7057L19.9992 25.7058L19.9934 25.7058C18.1605 25.7175 16.3748 26.2897 14.8765 27.3456L14.8765 27.3456L14.8709 27.3496L14.7884 27.4084L14.7877 27.4089L10.7239 30.3116C10.4521 30.5057 10.2276 30.6141 10.0652 30.6658C10.055 30.669 10.0453 30.6719 10.0361 30.6746C10.0344 30.6484 10.0334 30.6185 10.0334 30.5849C10.0334 29.686 9.83652 28.5998 9.44229 27.7004C9.24483 27.2499 8.96972 26.7812 8.58707 26.4091C8.19314 26.026 7.63844 25.7057 6.94352 25.7057H6.30506C3.72535 25.7057 1.63408 23.6144 1.63408 21.0346V14.4528C1.63408 12.2536 1.63502 10.6763 1.73613 9.43868C1.83611 8.21506 2.028 7.42948 2.35159 6.7944L2.3516 6.79439C2.98272 5.55572 3.9898 4.54864 5.22847 3.91751L5.22848 3.91751C5.86356 3.59392 6.64914 3.40203 7.87277 3.30205C9.1104 3.20093 10.6877 3.2 12.8869 3.2H19.1133C21.3126 3.2 22.8899 3.20093 24.1275 3.30205C25.3511 3.40203 26.1367 3.59392 26.7719 3.91752C28.0105 4.54864 29.0176 5.55571 29.6486 6.79434ZM4.68993 2.86055L4.68369 2.8483L4.68993 2.86055Z" stroke="black" stroke-width="2.4"/>
    <rect
      x="8.3584"
      y="16.717"
      width="15.8491"
      height="2.4"
      rx="1.2"
      fill="black"
    />
    <rect
      x="8.3584"
      y="9.9245"
      width="10.1887"
      height="2.4"
      rx="1.2"
      fill="black"
    />
  </svg>
</template>

<script setup>
  defineOptions({
    name: 'SupportChatIcon',
  });
</script>
